// extracted by css-extract-rspack-plugin
export default {"form":"nSShBI8iogs2K0hK__form___","footer":"MrDZzvQsTkvjQ_uI__footer___"};